import { useConfigurationSelector } from "@redux/reducers/appConfig";
import {
  useBusinessModelSelector,
  useFinanceSimulationSelector,
} from "@redux/reducers/deal";
import { useIsKeyAccount } from "@redux/reducers/auth";
import { getSolJourneyConfigForJourney } from "@shared/v2/lib/getSolJourneyConfigForJourney";
import { computeAvailableRegistrationMethods } from "@lib/computeAvailableRegistrationMethods";
import { useResolvedRegistrationPostalCode } from "@hooks/useResolvedRegistrationPostalCode";

export const useAvailableRegistrationMethods = () => {
  const configuration = useConfigurationSelector();
  const businessModel = useBusinessModelSelector();
  const financeSimulation = useFinanceSimulationSelector();
  const isKeyAccount = useIsKeyAccount();
  const registrationPostalCode = useResolvedRegistrationPostalCode();

  const { vehicleRegistration } = getSolJourneyConfigForJourney(
    financeSimulation.journey,
    businessModel,
    configuration
  );

  return computeAvailableRegistrationMethods(
    vehicleRegistration,
    registrationPostalCode,
    { isKeyAccount }
  );
};
